import React, { createContext, useCallback, useEffect, useState } from 'react'
import Axios from 'axios'
import { API_URI } from 'config'
import useAuth from 'app/hooks/useAuth'

const initialState = {
    dashboardData: null,
    loading: false,
    error: null,
    refetch: () => {},
}

const DashboardContext = createContext(initialState)

export const DashboardProvider = ({ children }) => {
    const { isAuthenticated, isInitialised, user } = useAuth()
    const [dashboardData, setDashboardData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    // Club admin dashboard counts only — not used by SA analytics
    const shouldFetch =
        isInitialised &&
        isAuthenticated &&
        Boolean(user) &&
        user.role !== 'SA'

    const fetchDashboard = useCallback(async () => {
        if (!shouldFetch) {
            setDashboardData(null)
            setLoading(false)
            setError(null)
            return
        }

        setLoading(true)
        setError(null)
        try {
            const { data } = await Axios.get(
                `${API_URI}/api/admin/get-counts-for-dashboard`
            )
            setDashboardData(data)
        } catch (err) {
            setError(
                err?.response?.data?.msg ||
                    err?.message ||
                    'Failed to load dashboard'
            )
            setDashboardData(null)
        } finally {
            setLoading(false)
        }
    }, [shouldFetch])

    useEffect(() => {
        fetchDashboard()
    }, [fetchDashboard])

    const value = {
        dashboardData,
        loading,
        error,
        refetch: fetchDashboard,
    }

    return (
        <DashboardContext.Provider value={value}>
            {children}
        </DashboardContext.Provider>
    )
}

export default DashboardContext
